import { makeStyles } from '@mui/styles';
import React from 'react';

import CheckBoxCell from './custom-cells/CheckBoxCell';
import DropDownCell from './custom-cells/DropDownCell';
import TextFieldCell from './custom-cells/TextFieldCell';

const useStyles = makeStyles({
  root: {
    display: 'block !important',
    padding: '10px 0',
  },
  row: {
    display: 'flex',
    marginBottom: 10,
    maxWidth: 600,
  },
  firstColumn: {
    display: 'flex',
    alignItems: 'end',
    width: '40%',
    fontSize: 16,
  },
  secondColumn: {
    width: '60%',
  },
});

const ExpandableComponent = ({ row }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <div className={classes.firstColumn}>{'Allow User Value'}</div>
        <div className={classes.secondColumn}>
          <CheckBoxCell row={row} column={{ accessor: 'allowChange' }} inSubRow />
        </div>
      </div>
      <div className={classes.row}>
        <div className={classes.firstColumn}>{'Label'}</div>
        <div className={classes.secondColumn}>
          <TextFieldCell row={row} column={{ accessor: 'label' }} isInExpandableRow />
        </div>
      </div>
      <div className={classes.row}>
        <div className={classes.firstColumn}>{'Translate Label'}</div>
        <div className={classes.secondColumn}>
          <DropDownCell
            row={row}
            column={{ accessor: 'translateLabel', isConditional: true }}
            isInExpandableRow
          />
        </div>
      </div>
      <div className={classes.row}>
        <div className={classes.firstColumn}>{'Validation'}</div>
        <div className={classes.secondColumn}>
          <DropDownCell row={row} column={{ accessor: 'validateValue' }} isInExpandableRow />
        </div>
      </div>
    </div>
  );
};

export default ExpandableComponent;
